// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"36f61637","290":"ac267c73","457":"0c39543e"}[chunkId] + ".chunk.js";
};